<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="m-h-10 p-v-10 p-h-10" style="background-color: #F9F9F9">
    <div class="w-full flex m-b-10">
      <slot name="leftBtn"></slot>

      <div class="w-full m-b-5">
        <Tag v-for="(item,index) in iconTypeList"
             type="dot"
             class="m-b-5"
             :color="selIconType === item.id? 'primary':'default'"
             @click.native="selIconType = item.id"
        >
          {{ item.name }}
        </Tag>
      </div>
<!--      <Select class="m-r-15" style="width:120px" v-model="selIconType">-->
<!--        <Option :key="item.id" :value="item.id" v-for="(item,index) in iconTypeList">{{item.name}}</Option>-->
<!--      </Select>-->
      <!--<class-choose-widget :gutter="10" :srcType="6" @dataChange="onClassGroupChange" leftPlaceholder="图标分类"-->
      <!--rightPlaceholder="图标分组"-->
      <!--style="width: 240px;" v-if="selIconType === 1">-->
      <!--</class-choose-widget>-->
      <!--<Input class="m-l-15" placeholder="图标名称" style="width: 160px" v-if="selIconType === 1" v-model="searchName"/>-->
      <!--<Button @click="onSearchClick" class="m-h-15" v-if="selIconType === 1">搜索</Button>-->

      <div class="flex-1 flex-shrink-1 j-end"></div>

      <up-load-image :multiple="multiple" :picurl="picurl" @uploadSuccess="uploadcoversuccess($event)"
                     accept="image/*"
                     style="width: auto;"
                     v-if="selIconType === 1">
        <template v-slot:tip>
          <Button class="" type="primary">本地上传</Button>
        </template>
      </up-load-image>

    </div>
    <!--列表数据-->
    <div class=" scrollbar  o-y-auto  p-t-10" style="height: 480px;">
      <div class="list-container" style="width:100%;top: 60px;overflow: hidden">

        <div :class="{'item-selected':isSelect(item),'item-normal':!isSelect(item),'m-r-12':index %10!==9}"
             :key="index" @click="itemClick(item,index)" class=" m-b-10 item"
             v-for="(item,index) in dataList">
          <div class="w-full h-full">
            <div style="position: relative;height: 92px;width: 92px">
              <div class="o-hidden flex a-center j-center border p-2"
                   style="height: 90px;width: 90px;background-color: #dcdfe6">
                <img
                  :src="(!item.url)?require('../../assets/common/ic_wutu@2x.png'):item.url + '?x-oss-process=image/resize,w_200,limit_1/format,png'"
                  style="width: 100%;min-height: 92px"/>
              </div>
              <!--鼠标悬停编辑-->
              <!--<div class="flex a-end j-center  w-full h-full  item-editable"-->
              <!--style="position: absolute;bottom: 0;left: 0;right: 0;height: 30px;background-color: #0000004d">-->
              <!--<div @click.stop="" class="w-24 h-24 b-round flex a-center j-center" style="cursor: pointer;">-->
              <!--<img class="w-20 h-20" src="../../assets/common/ic-link@2x.png" v-clipboard:copy="item.url"-->
              <!--v-clipboard:error="copyOnError" v-clipboard:success="copy"/>-->
              <!--</div>-->
              <!--&lt;!&ndash;<div @click.stop="itemDelete(item,index)"&ndash;&gt;-->
              <!--&lt;!&ndash;class="w-24 h-24 b-round flex a-center j-center m-l-25"&ndash;&gt;-->
              <!--&lt;!&ndash;style="cursor: pointer;">&ndash;&gt;-->
              <!--&lt;!&ndash;<img class="w-20 h-20" src="../../../assets/common/ic-delete@2x.png"/>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
              <!--</div>-->
              <!--鼠标悬停三角-->
              <div class="triangle" style="position: absolute;top: 0;right: 2px;" v-if="isSelect(item)">
              </div>
              <!--鼠标悬停对号-->
              <img class="w-16 h-16" src="../../assets/common/ic-right@2x.png"
                   style="position: absolute;top: 0;right: 2px;" v-if="isSelect(item)">
            </div>
            <!--<div class="lin2 m-h-5 m-t-12">{{ item.title }}</div>-->
          </div>
        </div>

      </div>
    </div>
    <Page :current="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.total"
          @on-change="onPageChange"
          class="m-t-10  w-full" show-total/>
  </div>
</template>

<script>
import ClassChooseWidget from '../common/ClassChooseWidget'
import UpLoadImage from '../common/UpLoadImage'
import {mapActions} from 'vuex'

export default {
  name: 'IconLibWidget',
  components: {UpLoadImage, ClassChooseWidget},
  props: {
    selectObj: {
      type: Object,
      default: () => {
        return {
          maps: new Map(),
          mapLength: 0
        }
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    picurl: {
      type: String,
      default: 'platform/icon/module/',
    },
    modalShowHide:{
      type:Boolean,
      default:false
    }
  },

  data () {
    return {
      selIconType: 2,
      iconTypeList: [
        {
          id: 2,
          name: '系统图标'
        },{
          id: 1,
          name: '自定义图标'
        },
      ],

      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: ''
      },
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 100,
      },
      // 列表数据
      dataList: [],
      //显示隐藏
      modalShowHide: false,
      //搜索名称
      searchName: ''
    }
  },
  watch: {
    selIconType: {
      handler (newValue) {
        this.tablePage.currentPage = 1
        this.getPicListData()
      },
      immediate: true
    },
    modalShowHide: {
      handler (newValue) {
        if (!newValue){
          this.selIconType = 2
        }
      },
      immediate: true
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    getPicListData () {
      if (parseInt(this.selIconType) === 1) {
        this.getCustomPicListData()
      } else if (parseInt(this.selIconType) === 2) {
        this.getSystemPicListData()
      }
    },
    getSystemPicListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      this.dataList = []
      this.getSysPicLists(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.imgId = child.id
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },
    getCustomPicListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchName) {
        params.title = this.searchName
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }
      this.dataList = []
      this.getIconLists(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.imgId = child.id
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },

    uploadcoversuccess (data) {
      if (data && data.length) {
        let params = data.map(res => {
          return {
            // title: res.oldname || '',
            url: res.url,
            // width: res.width,
            // height: res.height,
            // groupId: this.objChange.groupId || 0,
            // categoryId: this.objChange.classId || 0,
            // desc: ''
          }
        })
        this.addNewIcon(params).then(res => {
          if (res.code === 0) {
            this.tablePage.currentPage = 1
            this.getPicListData()
          }
        })
      }
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    copyOnError (e) {
      this.$Message.info('复制失败')
    },
    itemClick (item, i) {
      let id = item.imgId
      if (this.multiple) {
        if (this.selectObj.maps.has(id)) {
          this.selectObj.maps.delete(id)
        } else {
          this.selectObj.maps.set(id, item)
        }
      } else {
        this.selectObj.maps.clear()
        this.selectObj.mapLength = 0
        this.selectObj.maps.set(id, item)
      }
      this.selectObj.mapLength = this.selectObj.maps.size
    },
    isSelect (item) {
      let id = item.imgId
      if (this.selectObj.mapLength && this.selectObj.maps.has(id)) {
        return true
      } else {
        return false
      }
    },
    /**
     * 输入搜索筛选
     */
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getPicListData()
    },

    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      this.tablePage.currentPage = 1
      this.getPicListData()
    },
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.getPicListData()
    },

    ...mapActions([
      'getIconLists',
      'getSysPicLists',
      'delPic',
      'addNewIcon'
    ])
  }
}
</script>


<style lang="scss" scoped>

  .list-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    overflow-x: hidden;
  }

  .item {
    width: 94px;
    height: 94px;
    flex-direction: row;
  }

  .item-selected {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid #0EA4FB;
  }

  .item-normal {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid transparent;
  }

  .item-editable {
    display: none;
  }

  .item:hover .item-editable {
    display: flex;
  }

  .lin2 {
    color: #333;
    max-width: 600px;
    font-size: 13px;
    line-height: 20px;
    //height: 40px;
    //margin-top: 6px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 1; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }


  .triangle {
    width: 0;
    height: 0;
    border-color: transparent #0F8CFB;
    border-width: 0 25px 25px 0;
    border-style: solid;
  }

  .modal-product-link ::v-deep {
    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }

  //扩大商品链接按钮点击范围
  .icon-link {
    padding: 7px;
    margin: 0;
  }

  //扩大商品链接按钮点击范围
  #input-product ::v-deep {
    .ivu-input-group-append {
      padding: 0;
    }
  }
</style>
